import { render, staticRenderFns } from "./RolesEdit.vue?vue&type=template&id=43d9d3aa&"
import script from "./RolesEdit.vue?vue&type=script&lang=js&"
export * from "./RolesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports